import { render, staticRenderFns } from "./HistoryItem.vue?vue&type=template&id=12bba446"
import script from "./HistoryItem.vue?vue&type=script&lang=js"
export * from "./HistoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports